import React from "react";
import "../style.css";

// images
import loginImage from "../assets/img/LoginImage.png";
import smpassLogo from "../../assets/img/smilepass-logo.svg";

// Two-column auth/onboarding layout: content (left) + brand image (right).
//
// Uses explicit flex widths on plain divs rather than antd <Row>/<Col>. The
// antd grid was not reliably splitting the columns on some onboarding steps
// (e.g. sikka_setup): the columns collapsed to ~95/5 and the shared
// `.sider-cover-image` (position:absolute, 100%×100% of its column) then filled
// the ballooned image column and swallowed the whole viewport, crushing the form
// into a thin sliver. Hard flex widths + a positioned/overflow-hidden image
// column keep the split fixed and the cover image confined to its own column.
//
// `variant="wide"` gives the content column more room (subscription-plan +
// portal-credentials steps) while keeping the brand image on the right.
const LoginLayout = ({ children, variant }) => {
  const wide = variant === "wide";
  const contentPct = wide ? 62.5 : 50; // matches the old 15/9 vs 12/12 antd split
  const imagePct = 100 - contentPct;

  return (
    <div
      className="login-container"
      style={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        alignItems: "stretch",
        width: "100%",
        backgroundColor: "#EEECFC",
      }}
    >
      <div
        style={{
          flex: `0 0 ${contentPct}%`,
          maxWidth: `${contentPct}%`,
          minWidth: 0,
          boxSizing: "border-box",
        }}
      >
        <div
          className={`login-content${wide ? " login-content--wide" : ""}`}
          style={{ backgroundColor: "#EEECFC" }}
        >
          <img alt="logo" src={smpassLogo} width={280} style={{ marginBottom: 30 }} />
          <div className="mt8p">{children}</div>
        </div>
      </div>

      <div
        style={{
          flex: `0 0 ${imagePct}%`,
          maxWidth: `${imagePct}%`,
          position: "relative",
          overflow: "hidden",
        }}
      >
        <img className="sider-cover-image" src={loginImage} alt="dentist" />
      </div>
    </div>
  );
};

export default LoginLayout;
